import { Link } from "react-router-dom";

const FRIEND_LINKS = ["影视风向标", "剧情研究所", "光影档案馆", "角色志", "放映厅日报"];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/10">
                <i className="ri-movie-2-line text-2xl text-background-50"></i>
              </span>
              <div>
                <p className="font-heading text-xl font-extrabold text-background-50">亲吻姐姐</p>
                <p className="text-xs tracking-widest text-primary-200">MOVIE · SERIES · ANALYSIS</p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-100/90">
              亲吻姐姐是聚焦影视剧资讯、剧情解析与角色剖析的专业内容站。我们帮助观众读懂剧情脉络、理解角色动机，
              让每一次观影都更有收获。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs text-primary-100">
                <i className="ri-newspaper-line"></i>
                每日更新影视资讯
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs text-primary-100">
                <i className="ri-user-star-line"></i>
                深度角色分析
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/category" className="transition-colors hover:text-accent-300">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-100/90">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-300">首页</Link>
              </li>
              <li>
                <Link to="/category" className="transition-colors hover:text-accent-300">影视分类</Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-300">关于我们</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-accent-300">联系反馈</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/about" className="transition-colors hover:text-accent-300">
                友情链接
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-100/90">
              {FRIEND_LINKS.map((link) => (
                <li key={link}>
                  <Link to="/about" className="transition-colors hover:text-accent-300">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-primary-200/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 亲吻姐姐 · 保留所有权利。站内影视作品与人物均为演示示例，不含真实影星信息。</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-300">版权声明</Link>
            <Link to="/about" className="transition-colors hover:text-accent-300">法律声明</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}